import React from 'react';
import styled from 'styled-components';
import { useConfig } from '../../hooks';
import { isUnpublishedEntry } from './view-model-error.types';
export function ViewModelError({ model }) {
    const { environment } = useConfig();
    if (environment === 'production') {
        return null;
    }
    return (React.createElement(WarningBlock, null,
        React.createElement(WarningHeading, null, "Warning: rendering issue"),
        isUnpublishedEntry(model) && (React.createElement("span", null, "Unpublished content is missing here.")),
        React.createElement(WarningCode, null, JSON.stringify(model, null, 1))));
}
const WarningBlock = styled.div `
  background-color: #ffa500;
  color: #fff;
  border-radius: 1rem;
  padding: 0.75rem 1.5rem;
`;
const WarningHeading = styled.h3 `
  color: #000;
`;
const WarningCode = styled.code `
  display: block;
  color: #000;
  font-size: 0.75rem;
  padding-top: 0.75rem;
`;
//# sourceMappingURL=ViewModelError.js.map